export const getIDFromUrl = (url: string): string | null => {
  const parts = url.split("/");
  const id = parts[parts.length - 1];
  return id;
};

export const getIDFromCurrentURL = (): string | null => {
  const path = window.location.pathname;
  return getIDFromUrl(path);
};
